import Compressor from 'compressorjs';

export const compressionSettings = {
  photoLow: {
    quality: 0.9,
    maxHeight: 150,
    maxWidth: 150,
    mimeType: 'image/webp',
  },
  photoHigh: {
    quality: 0.9,
    maxHeight: 1200,
    maxWidth: 1600,
    mimeType: 'image/webp',
  },
};

export const appleFormatToJPG = async (file: File) => {
  const blob = new Blob([file], { type: 'image/heic' });
  const nameParts = file.name.split('.');
  nameParts.pop();
  const namePart = nameParts.join();
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const heicConvert = require('heic2any');
  const img = await heicConvert({
    blob,
    toType: 'image/jpeg',
    quality: 0.92,
  });

  return new File([img as Blob], `${namePart}.jpg`, { type: 'image/jpeg' });
};

const promisifiedCompress = async (file: File, options: Compressor.Options) => {
  return new Promise<File>((resolve, reject) => {
    new Compressor(file, {
      ...options,
      success(result) {
        resolve(result as File);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

export const compressImage = async (file: File) => {
  const [photoLow, photoHigh] = await Promise.all([
    promisifiedCompress(file, compressionSettings.photoLow),
    promisifiedCompress(file, compressionSettings.photoHigh),
  ]);

  return { photoLow, photoHigh };
};

export const fileToUrl = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsDataURL(file);
  });
};
